// InStockBadge - Subtle badge shown on search cards whose stock-aware
// resolver confirmed at least one linked product in stock at a nearby
// branch. Styled to match the CLOSEST / BEST PRICE / PREFERRED badges
// already used on the master product detail page (text-[11px], muted
// 50/600 colour pair, rounded-md, uppercase, no icon, no border) so the
// search and detail pages feel like the same visual system.

import { IN_STOCK_LABEL } from '../../constants/display'

export interface InStockBadgeProps {
  className?: string
  // Replaces the default in-stock text — a prioritised search card passes
  // the named branch's counts ("12 in branch · 40 in supplier warehouse", DEV-50739).
  label?: string | null
}

export function InStockBadge({ className = '', label = null }: InStockBadgeProps) {
  return (
    <span
      className={`inline-block whitespace-nowrap text-[11px] bg-emerald-50 text-emerald-600 px-2 py-0.5 rounded-md font-medium ${className}`}
    >
      {label ?? IN_STOCK_LABEL}
    </span>
  )
}
